import { Routes } from '@angular/router';

import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import { DatacenterViewCustomizationComponent }
	from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import { SERVICE_ANALYTICS } from '../shared/models/list';

export const routes: Routes = [
	{
		path: 'users',
		children: [
			{
				path: '',
				redirectTo: 'datacenter',
				pathMatch: 'full',
				data: { pageName: 'Redirect' }
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Users - Datacenter',
							service: SERVICE_ANALYTICS.USER,
							type: 'users',
							title: 'datacenter.users',
							exportExcelName: 'Users'
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: { pageName: 'Users - Datacenter Customization', service: SERVICE_ANALYTICS.USER }
					}
				]
			}
		]
	}
];
